export const profilesConstants = {
    PROFILES_FETCH: 'PROFILES_FETCH',
    PROFILES_SUCCESS: 'PROFILES_SUCCESS',
    PROFILES_ERROR: 'PROFILES_ERROR',
    PROFILES_FILTER_SUCCESS: 'PROFILES_FILTER_SUCCESS',
    PROFILES_FILTER_ERROR: 'PROFILES_FILTER_ERROR',
    SET_SYNC_STATUS: 'SET_SYNC_STATUS',
    SET_PROFILES: 'SET_PROFILES',
    MARK_LOCATION_PUBLISHING: 'MARK_LOCATION_PUBLISHING',
};

export const SYNC_TYPE = {
    ['N/A']: 0,
    SYNCED: 1,
    ACTION_REQUIRED: 2,
    IN_PROGRESS: 3,
    SYNCED_WITH_CONFLICTS: 4,
    DISCONNECTED: 5,
};

// Wire-format enum — sent to backend as `views[]`. Keep numeric values stable.
export const SYNC_VIEW = {
    DISABLED: 0,
    SYNCED: 1,
    CONFLICT: 2,
    NOT_PUBLISHED: 3,
    IN_PROGRESS: 4,
};

// FE-only chip variant. Splits Conflict/NotFound/NotVerified per row using fields
// the aggregate counts can't see.
export const SYNC_BADGE = {
    DISABLED: 0,
    SYNCED: 1,
    CONFLICT: 2,
    NOT_FOUND: 3,
    NOT_VERIFIED: 4,
    IN_PROGRESS: 5,
    DISCONNECTED: 6,
};

export const STORE_TYPE = {
    MAIN_PAGE: '1',
    CREATE_STORE: '2',
    CONNECT_STORE: '3',
};

export const SyncDiff = {
    LocationName: 1,
    Status: 2,
    PhoneNumber: 3,
    Email: 4,
    Website: 5,
    Address: 6,
    BusinessHours: 7,
    Description: 8,
    OpeningDate: 9,
    Logo: 10,
    CoverPhoto: 11,
    Facebook: 12,
    Instagram: 13,
    Youtube: 14,
    X: 15,
    LinkedIn: 16,
    Tiktok: 17,
    Pinterest: 18,
    Chat: 19,
    PrimaryCategory: 20,
    SecondaryCategories: 21,
    SpecialHours: 22,
    NotPublished: 23,
    ParentLocation: 24,
    AdditionalPhones: 25,
};

export const ListingDirectoryPlatformId = 36;

export const GOOGLE_RESTRICTED_FIELD_REASON = 'LAT_LNG_UPDATES_NOT_PERMITTED';
export const GOOGLE_DESCRIPTION_URL_REASON = 'PROFILE_DESCRIPTION_CONTAINS_URL';
